/* eslint-disable default-param-last */
import {
  CERTS_LIST_ALL_TAB,
  CERTS_LIST_CANCELED_TAB,
  CERTS_LIST_DONE_TAB,
  CERTS_LIST_EXPIRED_TAB,
  CERTS_LIST_TODO_TAB,
} from '../../../components/CertsList/constant';
import { SET_ACTIVE_TAB, SET_ALL_TABS_COUNT, SET_TAB_COUNT } from '../types';

const INITIAL_STATE = {
  activeTab: null,
  tabsCount: {
    [CERTS_LIST_TODO_TAB]: 0,
    [CERTS_LIST_DONE_TAB]: 0,
    [CERTS_LIST_CANCELED_TAB]: 0,
    [CERTS_LIST_EXPIRED_TAB]: 0,
    [CERTS_LIST_ALL_TAB]: 0,
  },
};

const tabsReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action?.payload,
      };

    case SET_TAB_COUNT:
      return {
        ...state,
        tabsCount: {
          ...state.tabsCount,
          [action.payload.tabName]: action?.payload?.tabCount,
        },
      };
    case SET_ALL_TABS_COUNT:
      return {
        ...state,
        tabsCount: action.payload,
      };
    default:
      return state;
  }
};

export default tabsReducer;
